import { css } from "@emotion/react";

export const KarteInfo = () => {
  return <div id={"karte-id-info"} css={karteInfoContainer} />;
};

const karteInfoContainer = css({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  "> *:last-child": {
    marginBottom: "24px",
  },
});
